module.exports = __webpack_public_path__ + "static/media/RF_B.43ad408d.mp4";